import { render, staticRenderFns } from "./RegisterValues.vue?vue&type=template&id=53c41034&scoped=true&"
import script from "./RegisterValues.vue?vue&type=script&lang=ts&"
export * from "./RegisterValues.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterValues.vue?vue&type=style&index=0&id=53c41034&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c41034",
  null
  
)

export default component.exports